<template>
  <article class="">
     <cabeceraEN></cabeceraEN>
     <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>We have made a firm commitment to sustainable development</h2>
    </section>
     <section class="cont-1300">
       <div class="right">
       <img src="./1.jpg" alt="">
      </div>
      <div class="left">
        <h2>
         Environment, Energy, Health and Safety
        </h2>
        <div class="zurda zurdas">
              <ul class="owl-carousel">
                <li class="slide slide1">
                 <p>
                  Our Integrated Management System complies with ISO standards for quality, occupational health
and safety, environmental and energy management.<br><br>
                  At Compañía Mega S.A. we have framed a Management Policy based on 4 ethical principles:
Respect, Integrity, Transparency and Safety. We are guided by these fundamental Values, which are
also part of our Vision.<br><br>

                  The Management Policy formulated by our Management Team includes decisive actions to achieve continuous improvement in all these aspects
                  </p>
                </li>
                <li class="slide slide2">
                  <p>
                     These actions reaffirm the Company’s commitment to environmental compliance prioritizing
prevention over mitigation and collaborating with different stakeholders in the search for
environmentally friendly solutions while engaging contractors through the enforcement of
environmental criteria and the implementation of measures and technologies aimed at enhancing
environmentally friendly practices.
                    </p>
                </li>
              </ul>
          </div>
        
      </div>
     
    </section>
    <section class="acciones">
      <div class="cont-1170">
        <h2>Specific actions to achieve eco-efficiency</h2>
        <div class="mod">
          <ul>
            <li><img src="./check.png" alt=""> 
              Waste management and recycling
            </li>
            <li><img src="./check.png" alt=""> Use of sophisticated technologies in the design of gas flares to control and reduce fuel gas emissions.</li>
            <li><img src="./check.png" alt=""> Conduction of studies on air quality and gas emissions.</li>
             <li><img src="./check.png" alt=""> Use of residual nitrogen as sweep gas to reduce fuel gas consumption.</li>
            <li><img src="./check.png" alt=""> Reduction in special waste.</li>
             <li><img src="./check.png" alt=""> Use of dedicated BOG compressor to minimize energy consumption.</li>
            <li><img src="./check.png" alt=""> Addition of a turbine to utilize available pressure drop.</li>
            <li><img src="./check.png" alt=""> Afforestation of industrial sites and local sewage treatment.</li>
             <li><img src="./check.png" alt=""> Purchase of laboratory equipment to enhance monitoring and production capabilities.</li>
            <li><img src="./check.png" alt=""> Conduction of technical/economic feasibility studies on the use of turbine exhaust gases.</li>
            <li><img src="./check.png" alt=""> Reduction in the amount of smoke released into the atmosphere.</li>
            <li><img src="./check.png" alt=""> Treatment of CO 2 stream.</li> 
          </ul>
        </div>
        <video controls src="./video.mp4"></video>
      </div>
    </section>
     <span id="sistema-de-gestion"></span>
    <section class="acciones">
      <div class="cont-1170">
        <h2>Integrated Management System</h2>
        <div class="mod">
         <p>On November 1, 2002, Compañía Mega S.A. implemented an Integrated Management System (IMS).
This system has been gradually and substantially strengthened through multiple external
maintenance and recertification audits conducted by International accredited Certifying Agencies. At
present, Compañía Mega S.A. complies with the requirements of the following ISO standards: ISO
9001:2015 (Quality Management System), ISO 45001:2018 (Occupational Health and Safety
Management System), ISO 14001:2015 (Environmental Management System) and ISO
50001:2018 (Energy Management System) in the separation, transportation, and storage of the
liquid components of natural gas and the sale and shipment of its products.<br><br>

        At Compañía Mega we have risen to the challenge of implementing and keeping an Integrated
Management System based on four ISO standards. In order to comply with these 4 standards, we
must consider and assess multiple locations, contexts, cultures, and operating processes. Therefore,
process standardization and optimization and continuous improvement are an inherent part of our
culture.</p>
        </div>
         <div class="caja">
           <a href="static/pdf/COMPAÑIA%20MEGA%20S.A.%20(OAA%209001-2015)%20CERTIFICATE%20AR-O240585%20v01.pdf" target="_blank"><img  src="./1c.png"  alt=""></a>
           <a href="static/pdf/COMPAÑIA MEGA S.A. (OAA 14001-2015) CERTIFICATE AR-O240586 v01.pdf" target="_blank"><img  src="./2c.png"  alt=""></a>
           <a href="static/pdf/COMPAÑIA MEGA S.A. (UKAS 45001-2018) CERTIFICATE AR-U240587 v01.pdf" target="_blank"><img  src="./3c.png"  alt=""></a>
           <a href="static/pdf/Certificado 50001-2018.pdf" target="_blank"><img  src="./4c.png"  alt=""></a>
         </div>
      </div>
    </section>
      <section class="accionest acciones">
      <div class="cont-1170">
        <h2>Management Policy</h2>
         <img class="imgs" src="./4.png"  alt="">
      </div>
    </section>
    <pieEN></pieEN>
  </article>
</template> 

<script>
import $ from 'jquery'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'

export default {
  name: 'medioAmbienteEN',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted: function () {
    $('.zurda > ul').owlCarousel({
      autoplay: false,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: true,
      dots: false
    })
  },
  components: {
    CabeceraEN,
    PieEN
  }
}
import PieEN from '@/components/PieEN'
import CabeceraEN from '@/components/CabeceraEN'
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.owl-nav
  .owl-prev
    font-size: 40px !important
  .owl-next
    font-size: 40px !important
.comercio
  padding: 80px 0
  position: relative
  &:after
    content: ''
    height: 400px
    background: #004d9e
    width: 100%
    position: absolute
    z-index: 1
    top: 0
  h1
    text-align: center
    color: #fff
    font-size: 30px
    width: 100%
    position: relative
    z-index: 2
  .cont-1170
    max-width: 1170px
    display: flex
    flex-direction: column
    align-items: center
    padding-top: 40px
    width: 100%
    padding: 0 15px
    margin: 0 auto
    position: relative
    z-index: 2
    img
      max-width: 800px
      width: 100%
      margin: 0 auto
    video
      max-width: 700px
      width: 100%
      margin: 0 auto
      padding-top: 50px
.acciones
  background: #f5f6f6
  padding: 80px 0
  .cont-1170
    max-width: 1170px
    width: 100%
    padding: 0 15px
    margin: 0 auto
    display: flex
    flex-direction: column
    align-items: center
    h2 
       font-size: 30px 
       color: #004d9e
       padding-bottom: 20px
    .mod
      p
        font-size: 16px
        line-height: 30px
        color: #323232
        padding: 5px 20px
        margin-bottom: 30px
      ul
        width: 100%
        display: flex
        flex-wrap: wrap
        justify-content: space-between
        @media(max-width: 1200px)
          flex-direction: column
          justify-content: center
        li
          width: 45%
          position: relative
          font-size: 16px
          color: #323232
          line-height: 30px
          @media(max-width: 1200px)
            width: 100%
            padding-left: 20px
          img
            position: absolute
            left: -20px
            top: 9px
            @media(max-width: 1200px)
              left: 0

    .imgs
      max-width: 900px
      width: 100%
    .img
      margin-top: 30px
      max-width: 700px
      width: 100%
    video
      max-width: 1000px
      width: 100%
      margin: 0 auto
      padding-top: 60px
.accionest
  background: #fff
  h1
    padding-bottom: 40px
.secundario p 
  margin-bottom: 10px
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 40%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
      text-align: center
      width: 100%
.cont-1300
  display: flex
  align-items: center
  max-width: 1300px
  width: 100%
  padding: 0 15px
  margin: 0 auto
  @media(max-width: 800px)
    flex-direction: column
  .left
    width: 50%
    padding: 0 50px
    @media(max-width: 800px)
      width: 100%
      padding: 30px 10px
    h2
      font-size: 30px
      color: #004d9e
      position: relative
      margin-bottom: 60px
      &:after
        width: 80px
        height: 1px 
        background: #333
        content: ''
        position: absolute
        bottom: -30px
        left: 0
    p
      font-size: 16px 
      line-height: 30px
      color: #323232
  .right
    width: 50%
    @media(max-width: 800px)
      width: 100%
      margin-bottom: 20px
    video, img
      width: 100%
</style>



// WEBPACK FOOTER //
// src/components/medio-ambiente-en/medioAmbiente-en.vue